import type { UnnotifiedBadge } from "@tacklefour/api-types";
import { BadgeIcon, getTierColour } from "./badge-icons";

export function AchievementToast({
  badge,
  onDismiss,
}: {
  badge: UnnotifiedBadge;
  onDismiss: () => void;
}) {
  return (
    <div
      className="animate-slide-in-bottom pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-lg border bg-navy-900 p-4 shadow-lg"
      style={{ borderColor: getTierColour(badge.tier) }}
    >
      <BadgeIcon icon={badge.icon} tier={badge.tier} size="md" />

      <div className="flex-1 min-w-0">
        <p className="font-display text-xs font-bold uppercase tracking-wider text-primary">
          Achievement Unlocked!
        </p>
        <p className="font-display text-sm font-bold uppercase tracking-wide">
          {badge.name}
        </p>
        <p className="text-xs text-muted-foreground">{badge.description}</p>
        <p className="mt-0.5 text-xs font-semibold text-primary">
          +{badge.xpReward} XP
        </p>
      </div>

      <button
        onClick={onDismiss}
        className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
        aria-label="Dismiss"
      >
        <svg
          className="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
